import React, {useRef, useState} from "react";
import {makeStyles, TableCell, TableRow, Typography} from "@material-ui/core";
import clsx from "clsx";
import PropTypes from 'prop-types';
import moment from "libs/moment";
import Tr from "translations/Translations";
import AdditionalRoundPassiveStatusCell from "./AdditionalRoundPassiveStatusCell";
import AdditionalRoundPassiveService from "services/AdditionalRoundPassiveService";

const useStyles = makeStyles(theme => ({
    evenRow: {
        backgroundColor: theme.palette.background.default
    },
    lastRow: {
        borderBottom: `solid 3px ${theme.palette.primary.main}`
    }
}));

function AdditionalRoundPassiveRow(
    {
        demandId,
        additionalRound,
        rowNumber,
        working,
        editable
    }) {

    const classes = useStyles();
    const even = rowNumber % 2 === 1;
    const serverBrowserTimeDiff = useRef(moment(additionalRound.serverTime).diff(moment(), "s"));
    const [curWorking, setCurWorking] = useState(false);

    const refreshRow = async (sectionsToRefresh) => {
        await AdditionalRoundPassiveService.updateAdditionalPassiveRound(demandId, additionalRound.roundId, sectionsToRefresh);
    }

    const getRow = (element, index, array) => {
        const noOffer = element.identity === -1;
        const first = index === 0;
        const last = index >= array.length - 1;

        const rowSpan = noOffer ? 1 : array.length;
        return (<TableRow key={element.identity} className={clsx({[classes.evenRow]: even, [classes.lastRow]: last})}>
            {first && <TableCell rowSpan={rowSpan}>
                <Typography variant="body2">
                    {Tr('additional_offer_nr', {value: additionalRound.ordinalNumber})}
                </Typography>
            </TableCell>}
            <TableCell>
                <Typography>{element.name}</Typography>
            </TableCell>
            {first && <TableCell rowSpan={rowSpan}>
                <AdditionalRoundPassiveStatusCell
                    demandId={demandId}
                    working={working}
                    editable={editable}
                    rowWorking={curWorking}
                    setRowWorking={setCurWorking}
                    refreshRow={refreshRow}
                    additionalRound={additionalRound}
                    serverBrowserTimeDiff={serverBrowserTimeDiff}
                />

            </TableCell>}
        </TableRow>)
    }


    return (<>{
        additionalRound.contractors.map((element, index, array) => getRow(element, index, array))
    }
    </>)
}

AdditionalRoundPassiveRow.propTypes = {
    demandId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]).isRequired,
    editable: PropTypes.bool.isRequired,
    working: PropTypes.bool.isRequired,
    additionalRound: PropTypes.object.isRequired,
    rowNumber: PropTypes.number.isRequired,
}

export default AdditionalRoundPassiveRow;

